<template>
  <v-app id="inspire">
    <v-main>
      <Activation/>
    </v-main>
  </v-app>
</template>

<script>
import Activation from '../components/ActivationComponent'
export default {
  props: {
    source: String
  },
  components: {
    Activation
  }
}
</script>
